import React, { useEffect, useState } from "react";
import {
    Table,
    Button,
    Space,
    Popconfirm,
    Card,
    message
} from "antd";

import {
    useDispatch,
    useSelector
} from "react-redux";

import {
    fetchCuttingLogic,
    deleteCuttingLogic
} from "../cuttingLogicThunk";

import {
    setLogic
} from "../cuttingLogicSlice";
import { getAccessType } from "../../../../lib/functions";

const CuttingLogicTable = () => {
    const dispatch = useDispatch();
    const { logicList, deleting } = useSelector(s => s.cuttingLogic);

    let [access_type, access_type_set] = useState("");

    useEffect(() => {
        const access = getAccessType("purchase_entry");
        access_type_set(access);
    }, []);

    const handleDelete = (id) => {
        dispatch(deleteCuttingLogic(id))
            .unwrap()
            .then(() => {
                message.success("Deleted Successfully");
                dispatch(fetchCuttingLogic());
            })
            .catch((error) => {
                // Show backend error message
                message.error(error || "Failed to delete");
                console.error('Delete error:', error);
            });
    };

    const columns = [
        {
            title: 'Manufacturer',
            dataIndex: 'name',
            width: 250
        },
        {
            title: 'GTIN',
            render: r => `${r.gtin_from}-${r.gtin_to}`,
            width: 140
        },
        {
            title: 'Batch',
            render: r => `${r.batch_from}-${r.batch_to}`,
            width: 140
        },
        {
            title: 'Expiry',
            render: r => `${r.expiry_from}-${r.expiry_to}`,
            width: 140
        },
        {
            title: 'Serial',
            render: r => `${r.serial_from}-${r.serial_to}`,
            width: 140
        },
        {
            title: 'Actions',
            width: 180,
            fixed: 'right',
            render: r => (
                <Space>
                    {access_type == "WRITE" && (
                        <>
                            <Button
                                type='link'
                                onClick={() => {
                                    dispatch(setLogic({
                                        id: r.id,
                                        selectedManufacturer: r.manufacture_id,
                                        gtin_from: r.gtin_from,
                                        gtin_to: r.gtin_to,
                                        batch_from: r.batch_from,
                                        batch_to: r.batch_to,
                                        expiry_from: r.expiry_from,
                                        expiry_to: r.expiry_to,
                                        serial_from: r.serial_from,
                                        serial_to: r.serial_to
                                    }))
                                }}
                            >
                                Edit
                            </Button>

                            <Popconfirm
                                title='Delete this logic?'
                                onConfirm={() => handleDelete(r.id)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button
                                    danger
                                    type='link'
                                    loading={deleting}
                                >
                                    Delete
                                </Button>
                            </Popconfirm>
                        </>
                    )}

                </Space>
            )
        }
    ];

    return (
        <Card
            title="Configured Cutting Logic"
            style={{ marginTop: 16 }}
        >
            <Table
                rowKey='id'
                columns={columns}
                dataSource={logicList}
                scroll={{ x: 1000 }}
                pagination={{ pageSize: 10 }}
                size='small'
                locale={{
                    emptyText: 'No cutting logic configured yet'
                }}
            />
        </Card>
    );
};

export default CuttingLogicTable;